import React from 'react';
import Footer from '../../components/Footer';
import PharmacyImg from "../../assets/images/diplomao.jpeg";
import { Link } from 'react-router-dom';
import { ChevronRight, Award, PieChart, Utensils, Cake } from 'lucide-react';
import Title from '../../components/TitleComponent';

const DiplomaFoodProduction = () => {
  return (
    <div className="w-full relative font-poppins bg-gray-50">
      <Title canonicalPath="/programmes/diploma-courses/diploma-in-food-production" />
      <Title title="Diploma in Food Production at Maya Devi University" description="Join the Diploma in Food Production at MDU, Dehradun. Master culinary skills and food preparation techniques for a successful career in hospitality." />
      <div className="w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5">
        {/* Title Section */}
        <div className="text-center">
          <h2 className="mb-4 text-2xl md:text-6xl tracking-tight font-bold text-[#0e4d38] relative">
            Diploma in Food Production
            <div className="w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] absolute left-1/2 transform -translate-x-1/2 bottom-[-15px]"></div>
          </h2>
        </div>

        {/* About Section */}
        <div className="flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between items-center">
          <img 
            src={PharmacyImg} 
            alt="Food Production"
            className="md:w-[40%] rounded-lg shadow-lg transition-transform duration-300 hover:scale-105"
          />
          <div className="flex flex-col gap-4 md:w-1/2">
            <h4 className="font-bold text-xl md:text-3xl text-[#23376c]">About the Department</h4>
            <p className="text-justify md:text-lg text-gray-700">
              The Diploma in Food Production is a 1 ½ year program aimed at equipping students with culinary expertise and preparing them for thriving careers in the food service and hospitality industry. This professional diploma integrates foundational and managerial skills with practical culinary training, emphasizing health and safety standards.
            </p>
            <Link to="https://admission.maya.edu.in/" className="self-start">
              <button className="mt-5 md:mt-0 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] flex items-center gap-2 group">
                Register Now
                <ChevronRight className="group-hover:translate-x-1 transition-transform" size={20} />
              </button>
            </Link>
          </div>
        </div>

        {/* Programme Details Table */}
        <div className="bg-white shadow-md rounded-lg overflow-x-auto mb-10">
          <table className="min-w-full text-center text-sm font-light">
            <thead className="bg-[#23376c] text-white">
              <tr>
                <th className="px-6 py-4 font-semibold">Programme</th>
                <th className="px-6 py-4 font-semibold">Branch</th>
                <th className="px-6 py-4 font-semibold">Duration</th>
                <th className="px-6 py-4 font-semibold">Seats</th>
                {/* <th className="px-6 py-4 font-semibold">One-time Charges</th>
                <th className="px-6 py-4 font-semibold">Yearly Fee (India)</th>
                <th className="px-6 py-4 font-semibold">Yearly Fee (UK)</th> */}
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="whitespace-nowrap px-6 py-4 font-semibold">Diploma</td>
                <td className="whitespace-nowrap px-6 py-4">Food Production</td>
                <td className="whitespace-nowrap px-6 py-4">1</td>
                <td className="whitespace-nowrap px-6 py-4">20</td>
                {/* <td className="whitespace-nowrap px-6 py-4">Rs.11000/-</td>
                <td className="whitespace-nowrap px-6 py-4">Rs.60000/-</td>
                <td className="whitespace-nowrap px-6 py-4">Rs.45000/-</td> */}
              </tr>
            </tbody>
          </table>
        </div>

        {/* Details Sections */}
        <div className="grid md:grid-cols-2 gap-10 mb-[100px]">
          {/* Eligibility Criteria */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h4 className="text-2xl font-semibold text-[#0e4d38] mb-4 flex items-center">
              <Award className="mr-3 text-[#23376c]" /> Eligibility Criteria
            </h4>
            <p>10+2 (In any Stream)</p>
          </div>

          {/* Programme Outcomes */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h4 className="text-2xl font-semibold text-[#0e4d38] mb-4 flex items-center">
              <PieChart className="mr-3 text-[#23376c]" /> Programme Outcomes
            </h4>
            <ul className="list-disc pl-5 space-y-2">
              <li>Demonstrate advanced culinary skills in food preparation and presentation.</li>
              <li>Design innovative menus for diverse cuisines and dietary needs.</li>
              <li>Implement proper food safety and hygiene protocols.</li>
              <li>Enter the hospitality industry with confidence and expertise.</li>
            </ul>
          </div>

          {/* Career Prospects */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h4 className="text-2xl font-semibold text-[#0e4d38] mb-4 flex items-center">
              <Utensils className="mr-3 text-[#23376c]" /> Career Prospects
            </h4>
            <ul className="list-disc pl-5 space-y-2">
              <li>Hotels</li>
              <li>Airlines</li>
              <li>Tourism Administration</li>
              <li>Cruise Industry</li>
            </ul>
          </div>

          {/* Career Options */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h4 className="text-2xl font-semibold text-[#0e4d38] mb-4 flex items-center">
              <Cake className="mr-3 text-[#23376c]" /> Career Options
            </h4>
            <ul className="list-disc pl-5 space-y-2">
              <li>Chef</li>
              <li>Kitchen Trainer/Instructor</li>
              <li>Food Stylist</li>
              <li>Food Consultant</li>
              <li>Entrepreneur (Food Business)</li>
              <li>Quality Assurance Manager</li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DiplomaFoodProduction;
